export default __webpack_public_path__ + "static/media/locked.f92eb651.mp3";